import { memo } from 'react'
import { useDisclosure } from '@chakra-ui/react'

import { BubbleChat, EmptyBubbleChat } from 'components/icons'
import { IconButtonWithBadge } from 'components'

function MessagesButton() {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <IconButtonWithBadge
      onClick={onToggle}
      aria-label="Botão para abrir as suas notificações do sistema"
      variant="ghost"
      colorScheme="gray"
      icon={isOpen ? <BubbleChat /> : <EmptyBubbleChat />}
    />
  )
}

export default memo(MessagesButton)
